(function () {
    if (typeof window.terratype !== "undefined") {
        window.terratype.onRender(function (provider, map) {
            if (typeof map.positions !== "undefined" && map.positions.length) {
                var poi = map.positions[0];
                if (typeof poi !== "undefined" && poi != null && typeof window.google !== "undefined" && window.google != null && typeof window.google.maps !== "undefined" && window.google.maps != null) {
                    window.google.maps.event.trigger(poi.handle, "click");
                }
            }
        });
    }
})();